import { Injectable } from '@angular/core';
import { LocationDetails } from '../data-objects/location-details';
import { Observable } from 'rxjs/Observable';
import { ServiceBase } from './service-base';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { PostalAddress } from '../data-objects/postal-address';
import * as parser from '@payk/australia-address-parser';

@Injectable()
export class AddressService extends ServiceBase {

  private _bsPricingZone = new BehaviorSubject<string>('FMR CWW');

  setPricingZone(_pricingZone: string) {
    this._bsPricingZone.next(_pricingZone);
  }
  getPricingZone() {
    return this._bsPricingZone.asObservable();
  }

  public static get validateAddressUrl(): string {
    return ServiceBase.baseHref + '/api/validateAddress';
  }

  public static get validateInstallationNumberUrl(): string {
    return ServiceBase.baseHref + '/api/validateInstallationNumber';
  }
  public static get validatePropertyUrl(): string {
    return ServiceBase.baseHref + '/api/validateProperty';
  }

  private static objToSearchParams(obj): HttpParams {
    let params: HttpParams = new HttpParams();
    for (const key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] && obj[key] !== 'undefined' && obj[key] !== 'Please Select...') {
        params = params.set(key, obj[key]);
      }
    }
    return params;
  }

  constructor(private http: HttpClient) {
    super();
  }

  validateAddress(addr: LocationDetails, token: string): Observable<LocationDetails[]> {
    const addressDetails: LocationDetails = ServiceBase.sanitize(addr);
    const header: HttpHeaders = new HttpHeaders()
      .append('Content-Type', 'application/json')
      .append('Authorization', 'Bearer ' + token);
    const params: HttpParams = AddressService.objToSearchParams(addressDetails);

    return this.http.get<LocationDetails[]>(AddressService.validateAddressUrl, { headers: header, params: params });
  }

  validateInstallationNumber(installationNumber: any, token: string): Observable<LocationDetails[]> {
    const header: HttpHeaders = new HttpHeaders()
      .append('Content-Type', 'application/json')
      .append('Authorization', 'Bearer ' + token);
    const params: HttpParams = new HttpParams().set('installationNumber', installationNumber);

    return this.http.get<LocationDetails[]>(AddressService.validateInstallationNumberUrl, { headers: header, params: params });
  }

  validateProperty(installationNumber: string, token: string): Observable<void> {
    const params: HttpParams = new HttpParams().set('installationNumber', installationNumber);
    const header: HttpHeaders = new HttpHeaders()
      .append('Content-Type', 'application/json')
      .append('Authorization', 'Bearer ' + token);
    return this.http.get<void>(AddressService.validatePropertyUrl, { headers: header, params: params });
  }

  stateFromPostcode(postCode: string): string {
    const pCode: number = Number.parseInt(postCode);
    if (pCode >= 3000 && pCode <= 3999 || pCode >= 8000 && pCode <= 8999) {
      return 'VIC';
    } else if (pCode >= 4000 && pCode <= 4999 || pCode >= 9000 && pCode <= 9999) {
      return 'QLD';
    } else if (pCode >= 5000 && pCode <= 5999) {
      return 'SA';
    } else if (pCode >= 6000 && pCode <= 6999) {
      return 'WA';
    } else if (pCode >= 1000 && pCode <= 2599 || pCode >= 2619 && pCode <= 2898
      || pCode >= 2921 && pCode <= 2999 || pCode >= 200 && pCode <= 299) {
      return 'NSW';
    } else if (pCode >= 2600 && pCode <= 2618 || pCode >= 2900 && pCode <= 2920) {
      return 'ACT';
    } else if (pCode >= 7000 && pCode <= 7999) {
      return 'TAS';
    } else if (pCode >= 800 && pCode <= 999) {
      return 'NT';
    } else {
      return '';
    }
  }

  buildStructuredPostalFromPostalAddress(postalAddress: string): PostalAddress {
    const sp = new PostalAddress();
    const states = ['VIC','QLD','SA','WA','NSW','ACT','TAS','NT'];

    let postalAddrObj = postalAddress.split(' ');
    let postalAddrHasState: boolean = states
                                        .map((state: string) => ((postalAddrObj || []).indexOf(state || '') > -1))
                                        .reduce((p,c) => p || c, false);

    if (!postalAddrHasState) {
      const postcode = postalAddrObj[postalAddrObj.length - 1];
      const state = this.stateFromPostcode(postcode);

      if (state) {
        postalAddrObj.pop();
        postalAddrObj.push(state);
        postalAddrObj.push(postcode);
      }
    }

    const parsedAddress = parser.parseLocation(postalAddrObj.join(' '));

    sp.poBox = parsedAddress.propertyName ? parsedAddress.propertyName : null;
    sp.streetNumber = parsedAddress.streetNumber ? parsedAddress.streetNumber : null;
    sp.street = parsedAddress.streetName ? parsedAddress.streetName : null;
    sp.streetType = parsedAddress.streetType ? parsedAddress.streetType : null;
    sp.streetSuffixType = parsedAddress.streetSuffixType ? parsedAddress.streetSuffixType : null;
    sp.suburb = parsedAddress.suburb ? parsedAddress.suburb : null;
    sp.postCode = parsedAddress.postcode ? parsedAddress.postcode : null;

    return sp;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/address.service.ts